import metadata from '../metadata.json';

export class Helpers {

    static deleteAllCookies() {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }
    static saveToLocalStorage = (key, value) => {
        var oldValue = localStorage.getItem(key);
        if (oldValue !== value) {
            localStorage.setItem(key, value);
        }
    }
    static getAddonVersion = () => {
        return `${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision}`;
    }
    static getAppName = () => {
        return metadata.appName;
    }
    static getAppId = () => {
        return metadata.appId;
    }
    static isRebranded = () => {
        return metadata.isRebranded;
    }
    static getBaseUrl = () => {
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host;
        if (getUrl.port) {
            baseUrl += ':' + getUrl.port;
        }
        return baseUrl;
    }
    static getTemplogginData = () => {
        var userData;
        try {
            var url = localStorage.getItem('url');
            var username = localStorage.getItem('username');
            var userKey = localStorage.getItem('apiKey');
            var userId = localStorage.getItem('userId');
            var userImagebase64 = localStorage.getItem('userImagebase64');
            userData = {
                url: url,
                username: username,
                userKey: userKey,
                userId: userId,
                userImage: userImagebase64
            };
        } catch (e) {
            console.log(e);
        }
        return userData;
    }
    static checkUrl(url) {
        var validURL = url;
        try {
            if (url.substring(url.length - 1) != '/') {
                validURL = url + "/";
            }
            if (!(url.startsWith("http://")) && !(url.startsWith("https://"))) {
                validURL = "http://" + validURL;
            }
        } catch (e) {
        }
        return validURL;
    }
    static getUrlPar = (sParam, location = null) => {
        try {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;
            if (location)
                sPageURL = decodeURIComponent(location.search.substring(1))
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? '' : sParameterName[1];
                }
            }
        } catch (e) {
            return '';
        }
    }
    static ValidateEmail(inputText) {
        var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (inputText.match(mailformat)) {
            return true;
        }
        else {
            return false;
        }
    }
    static scrollIntoView = (object, panel: string | boolean) => (event, isExpanded: boolean) => {
        object.props.changeAccordion(isExpanded ? panel : false);
    }
    static formatTime(date) {
        var d = new Date(date),
            hr = d.getHours(),
            min = d.getMinutes();
        var minute = String(min);
        var hours = String(hr);
        if (hr < 10) {
            hours = "0" + hr;
        }
        if (min < 10) {
            minute = "0" + min;
        }
        return [hours, minute].join(':');
    }
    static char_count(str, letter) {
        var letter_Count = 0;
        for (var position = 0; position < str.length; position++) {
            if (str.charAt(position) == letter) {
                letter_Count += 1;
            }
        }
        return letter_Count;
    }
    static cleaningData(data) {
        var cleanedData = data;
        Object.entries(data).map(([key, value]) => {
            if (typeof value == 'string' || typeof value == 'boolean' || typeof value == 'number') {
                cleanedData[key] = encodeURIComponent(value);
            }
            if (value != null) {
                if (typeof value === 'string' || Array.isArray(value)) {
                    if (value.length == 0)
                        delete cleanedData[key];
                }
            }
            else
                delete cleanedData[key];
        });
        return cleanedData;
    }
    static getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    static buildEmailAddressString(address) {
        return address.displayName + " &lt;" + address.emailAddress + "&gt;";
    }
    static buildEmailAddressesString(addresses) {
        if (addresses && addresses.length > 0) {
            var returnString = "";
            for (var i = 0; i < addresses.length; i++) {
                if (i > 0) {
                    returnString = returnString + "<br/>";
                }
                returnString = returnString + Helpers.buildEmailAddressString(addresses[i]);
            }
            return returnString;
        }
        return "None";
    }
    static buildSpecialEmailAddressesString(addresses) {
        if (addresses && addresses.length > 0) {
            var returnString = "";
            for (var i = 0; i < addresses.length; i++) {
                returnString = returnString + addresses[i].emailAddress + ';';
            }
            return returnString;
        }
        return "None";
    }
    static jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    static blendColors(color1, color2, percentage) {
        // check input
        color1 = color1 || '#000000';
        color2 = color2 || '#ffffff';
        percentage = percentage || 0.5;

        // 2: check to see if we need to convert 3 char hex to 6 char hex, else slice off hash
        //      the three character hex is just a representation of the 6 hex where each character is repeated
        //      ie: #060 => #006600 (green)
        if (color1.length == 4)
            color1 = color1[1] + color1[1] + color1[2] + color1[2] + color1[3] + color1[3];
        else
            color1 = color1.substring(1);
        if (color2.length == 4)
            color2 = color2[1] + color2[1] + color2[2] + color2[2] + color2[3] + color2[3];
        else
            color2 = color2.substring(1);


        // 3: we have valid input, convert colors to rgb
        color1 = [parseInt(color1[0] + color1[1], 16), parseInt(color1[2] + color1[3], 16), parseInt(color1[4] + color1[5], 16)];
        color2 = [parseInt(color2[0] + color2[1], 16), parseInt(color2[2] + color2[3], 16), parseInt(color2[4] + color2[5], 16)];


        // 4: blend
        var color3 = [
            (1 - percentage) * color1[0] + percentage * color2[0],
            (1 - percentage) * color1[1] + percentage * color2[1],
            (1 - percentage) * color1[2] + percentage * color2[2]
        ];

        // 5: convert to hex
        var hexColor3 = '#' + Helpers.int_to_hex(color3[0]) + Helpers.int_to_hex(color3[1]) + Helpers.int_to_hex(color3[2]);

        // return hex
        return hexColor3;
    }

    /*
        convert a Number to a two character hex string
        must round, or we will end up with more digits than expected (2)
        note: can also result in single digit, which will need to be padded with a 0 to the left
        @param: num         => the number to conver to hex
        @returns: string    => the hex representation of the provided number
    */
    static int_to_hex(num) {
        var hex = Math.round(num).toString(16);
        if (hex.length == 1)
            hex = '0' + hex;
        return hex;
    }
    static lowerFirstLetter(string: string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    static base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }
};